/**
 * sortByTimeFilter
 *
 * @author Dec Norton <decnorton@gmail.com>
 */
import { hoursMinutesToSeconds } from '@shared/utils/datetime';

export function sortByTimeFilter() {
    return function(input, key) {
        if (!input || input.length === 0) {
            return input;
        }

        return input.sort((a, b) => {
            if (!a[key] || !b[key]) {
                return 0;
            }

            const aSeconds = hoursMinutesToSeconds(a[key]);
            const bSeconds = hoursMinutesToSeconds(b[key]);

            return aSeconds - bSeconds;
        });
    };
}
